const twoFactorAuthentication = {
  slug: 'two-factor-authentication',
  title: 'Two-factor authentication (2FA)',
  description:
    'Compare SMS codes, authenticator apps, and security keys — and why 2FA helps after phishing calls and smishing.',
  category: 'digital',
  guideType: 'guide',
  readMinutes: 5,
  partnerTip: 'none',
  relatedSlugs: ['password-managers', 'smishing', 'password-security-basics'],
  sections: [
    {
      type: 'paragraph',
      text: 'Two-factor authentication means something you know (password) plus something you have (phone, app, or security key). Even if a scammer gets your password, the second factor can stop account takeover.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'SMS codes',
    },
    {
      type: 'paragraph',
      text: 'Better than password alone, but vulnerable if a scammer tricks you into reading the code aloud, or if your SIM is swapped. Prefer app-based 2FA for important accounts when offered.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Authenticator apps',
    },
    {
      type: 'paragraph',
      text: 'Apps like those built into 1Password, Google Authenticator, or Microsoft Authenticator generate time-based codes on your device. Scammers cannot steal them unless they control your phone.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Hardware security keys',
    },
    {
      type: 'paragraph',
      text: 'Physical keys (FIDO2/WebAuthn) provide the strongest protection for email and high-value accounts. Keep a backup key or recovery codes in a safe place.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Priority accounts',
    },
    {
      type: 'list',
      items: [
        'Email and password manager',
        'Banking and payment apps',
        'Mobile phone account (SIM swap protection)',
        'Social and cloud storage used for account recovery',
      ],
    },
    {
      type: 'link',
      to: '/learn/what-not-to-do',
      label: 'Never share 2FA codes with callers',
    },
  ],
};

export default twoFactorAuthentication;
